export interface TimeDurations {
    id: number;
    value: string;
}
export const AccountMenuVersion = {
    V1: 1,
    V2: 2,
    V3: 3,
    V4: 4,
    V5: 5,
};
